export default __webpack_public_path__ + "static/media/i_bus-dbl_yl_tagless.dafe86f9.svg";